import axios from "axios";
import { logout } from "../lib/auth";
import { accountTableColumn } from "../config/account";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// MGR商材権限一覧取得
export async function getAccountMgrProducts(id: string) {
  try {
    const path = "accountMgrProducts";
    const params = { id };
    const response = await axios.get(CONST.apiUrl + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return {
      sudDatas: response.data.fetch_data,
      productDatas: response.data.product_data,
    };
  } catch (error) {
    return { sudDatas: [], productDatas: [] };
    // logout();
  }
}

// MGR商材権限登録
export async function postAccountMgrProduct(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "accountMgrProduct";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
